import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment-timezone';
import _ from 'lodash';

import {DatePicker} from '@otrl/ui';

import MomentPropTypes from "../../helpers/MomentPropTypes";

import PureRenderComponent from '../PureRenderComponent';

class Calendar extends PureRenderComponent {

    static propTypes = {
        show: PropTypes.bool,
        autoFocus: PropTypes.bool,
        selected: MomentPropTypes.isMoment,
        max: MomentPropTypes.isMoment,
        min: MomentPropTypes.isMoment,
        initialMonth: MomentPropTypes.isMoment,
        onChange: PropTypes.func,
        className: PropTypes.string,
    };

    static defaultProps = {
        selected: null,
        max: null,
        min: null,
        initialMonth: null,
        onChange: _.noop,
        show: false,
        autoFocus: false,
    };

    calendarRef = React.createRef();

    componentDidUpdate(prevProps) {
        const {show, autoFocus} = this.props;
        const datePicker = _.get(this.calendarRef, 'current');
        if (autoFocus && show && !prevProps.show && datePicker) {
            // Consider adding this functionality to the DatePicker itself
            const datePickerEl = ReactDOM.findDOMNode(datePicker);
            const selected = datePickerEl.querySelector('.DayPicker-Day--selected');
            const firstAvailableDay = datePickerEl.querySelector('.DayPicker-Day:not(.DayPicker-Day--disabled)');
            const wrapper = datePickerEl.querySelector('[tabindex="0"]');
            (selected || firstAvailableDay || wrapper).focus();
        }
    }

    _onChange = (date) => {
        this.props.onChange(moment(date));
    };


    render () {
        const { className, selected, min, max, initialMonth, numberOfMonths = 1} = this.props;

        const calendarProps = {
            selected: selected ? selected.toDate() : null,
            onChange: this._onChange,
            numberOfMonths
        };

        if (min) { calendarProps.minDate = min.toDate(); }
        if (max) { calendarProps.maxDate = max.toDate(); }
        if (initialMonth) { calendarProps.initialMonthDate = initialMonth.toDate(); }

        return (
            <div className="otrl-ui__widget--vertical" ref={this.calendarRef}>
                <DatePicker {...calendarProps} className={className}/>
            </div>
        );
    }

}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/form/Calendar.js